var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v13.5a2.5 2.5 0 0 0 2.5 2.5Zm0 0h.5a3 3 0 0 0 0-6h-.5M7 14.088h6M7 17h4.5M17 4a2 2 0 0 1 2 2v11m0 0v1.09c0 .503.407.91.91.91H20a1 1 0 0 0 0-2h-1ZM7.025 8.685V6h2.474c1.412 0 2.078 1.743 1.026 2.685m-3.5 0v2.684h3.3c1.672 0 1.853-2.438.2-2.684m-3.5 0h3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.2ad05085a8b315fccd4da6bfdb655684.svg";
export { ForwardRef as ReactComponent };